import React from "react";

/**
 * North Star LLC brand emblem. Renders the original PNG logo from
 * /images/logo.png; size and shape are controlled via `className`.
 */
export default function BrandMark({
    className = "w-12 h-12",
    title = "North Star LLC",
}) {
    return (
        <img
            src="/images/logo.png"
            alt={title}
            className={`${className} object-contain`}
        />
    );
}

/**
 * Wave divider used between sections — mirrors the brand's flowing
 * green wave motif. Pass `flip` to reverse the curve direction.
 */
export function BrandWave({ className = "w-full h-16", flip = false, tone = "deep" }) {
    const fillTop = tone === "deep" ? "#004D2E" : "#8CC63F";
    const fillMid = tone === "deep" ? "#00843D" : "#52a86f";
    const fillBot = tone === "deep" ? "#8CC63F" : "#FFD233";
    return (
        <svg
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            className={className}
            style={{ transform: flip ? "scaleY(-1)" : "none" }}
            aria-hidden="true"
        >
            <path
                d="M0,80 C240,120 480,40 720,60 C960,80 1200,120 1440,70 L1440,120 L0,120 Z"
                fill={fillTop}
                opacity="0.95"
            />
            <path
                d="M0,90 C240,60 480,110 720,80 C960,50 1200,90 1440,90 L1440,120 L0,120 Z"
                fill={fillMid}
                opacity="0.55"
            />
            <path
                d="M0,100 C240,90 480,120 720,100 C960,80 1200,110 1440,100 L1440,120 L0,120 Z"
                fill={fillBot}
                opacity="0.35"
            />
        </svg>
    );
}
